import { useApiClient } from "@/src/hooks/useApiClient";
import { useQueryErrorToast } from "@/src/hooks/useQueryErrorToast";
import { useTranslations } from "@/src/i18n/i18n";

/**
 * Les discussions d'un compte.
 *
 * ⚠️ **La liste ne charge aucun message.** Elle donne des lignes — qui,
 * combien, quand — et c'est en ouvrant l'une d'elles qu'on lit le fil. Ce n'est
 * pas seulement une économie : le serveur **journalise chaque lecture de
 * discussion**, et charger les trente fils d'un compte pour en afficher les
 * en-têtes inscrirait au registre trente consultations qui n'ont pas eu lieu.
 *
 * `enabled` sur `accountId > 0` : la fiche appelle ce hook avant de connaître
 * l'identifiant, et un `0` récolterait un 400.
 */
export function useAccountConversations(accountId: number | undefined) {
  const $api = useApiClient();
  const t = useTranslations("conversations");

  const { data, error, isError, isLoading } = $api.useQuery(
    "get",
    "/api/v1/moderation/accounts/{id}/conversations",
    { params: { path: { id: accountId ?? 0 } } },
    { enabled: (accountId ?? 0) > 0 },
  );

  useQueryErrorToast(isError, t("list-error"), error);

  return {
    conversations: data?.data?.conversations ?? [],
    total: data?.data?.total ?? 0,
    isLoading,
    isError,
  };
}
